/**
 * Toast Notifications Manager
 * Handles showing and hiding toast notifications
 */

class ToastManager {
  constructor() {
    this.toasts = new Map();
    this.init();
  }

  init() {
    // Initialize dismiss buttons for existing toasts
    document.addEventListener('DOMContentLoaded', () => {
      this.initDismissButtons();
    });
  }

  initDismissButtons() {
    document.querySelectorAll('[data-dismiss-target]').forEach(button => {
      button.addEventListener('click', () => {
        const targetId = button.getAttribute('data-dismiss-target');
        this.hideToast(targetId);
      });
    });
  }

  showToast(selector, autoHide = true, duration = 5000) {
    const toast = document.querySelector(selector);
    if (!toast) {
      console.error('Toast not found:', selector);
      return;
    }

    // Add show class to make it visible
    toast.classList.add('show');

    // Auto-hide after duration
    if (autoHide) {
      const timeoutId = setTimeout(() => {
        this.hideToast(selector);
      }, duration);

      this.toasts.set(selector, timeoutId);
    }
  }

  hideToast(selector) {
    const toast = document.querySelector(selector);
    if (!toast) return;

    // Clear timeout if exists
    if (this.toasts.has(selector)) {
      clearTimeout(this.toasts.get(selector));
      this.toasts.delete(selector);
    }

    // Remove show class
    toast.classList.remove('show');
  }
}

// Create global instance
window.toastManager = new ToastManager();

/**
 * Password Recovery Form Handler
 * Handles showing toast notification after successful password recovery submission
 */
class RecoverPasswordHandler {
  constructor() {
    this.init();
  }

  init() {
    document.addEventListener('DOMContentLoaded', () => {
      this.checkForShowMessage();
    });
  }

  checkForShowMessage() {
    // Check if URL has show_message=true query parameter
    const urlParams = new URLSearchParams(window.location.search);
    const showMessage = urlParams.get('show_message');

    if (showMessage === 'true') {

      // Show success toast
      setTimeout(() => {
        if (window.toastManager) {
          window.toastManager.showToast('#toast-success', true, 5000);
        }
      }, 300);

      // Remove the query parameter from the URL without reloading
      const url = new URL(window.location);
      url.searchParams.delete('show_message');
      window.history.replaceState({}, '', url);
    }
  }
}

// Initialize recover password handler
window.recoverPasswordHandler = new RecoverPasswordHandler();
